import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getIsFeatureHasAnOption } from 'src/utils/featureToggle';
import {
  getPriceInfo,
  getRemainingPaymentAmount,
  getIsRegularFlight,
  getIsOrderPrebuildFetching,
} from 'checkout/store/selectors/order';
import {
  getShowPriceChanged,
  getPriceChangeDirection,
} from 'checkout/store/selectors/actualization';
import { upgradedServicesSelector } from 'checkout/CheckoutRoutes/PackageCheckout/store/actualize-alternatives';
import { getHotelLinkWithRequestId } from 'checkout/store/selectors/hotel';
import { getIsMobile } from 'src/store/view/selectors';
import { getInstantConfirm } from 'checkout/store/selectors/package';
import Summary from 'checkout/components/PriceSummary/Summary';
import PriceInfo from 'checkout/components/PriceSummary/PriceInfo';
import Preloader from 'src/components/Preloader';
import PriceInfoMobile from 'checkout/components/PriceSummary/PriceInfoMobile';
import PackageId from 'checkout/components/PackageId';
import { PriceChangeDirectionPropTypes } from 'checkout/CheckoutRoutes/PackageCheckout/proptypes/actualization';
import SidebarPrice from './SidebarPrice';

const baseCls = 'checkout-sidebar-summary';

const SidebarSummary = ({
  priceInfo,
  upgradedServicesInfo,
  fullPrice,
  showPriceChanged,
  isRegularFlight,
  priceChangeDirectionType,
  hotelLink,
  instantConfirm,
  isFetching,
  isMobile,
}) => {
  const priceInfoWithUpgradedServices = priceInfo?.concat(upgradedServicesInfo);
  return (
    <div className={baseCls}>
      <SidebarPrice
        className={`${baseCls}__checker`}
        showPriceChanged={showPriceChanged}
        isRegularFlight={isRegularFlight}
        priceChangeDirectionType={priceChangeDirectionType}
        hotelLink={hotelLink}
        isMobile={isMobile}
      >
        {isFetching ? (
          <Preloader throbber className={`${baseCls}--throbber`} />
        ) : (
          <Summary value={fullPrice} instantConfirm={instantConfirm}>
            {isMobile && <PackageId />}
          </Summary>
        )}
      </SidebarPrice>
      <div className={`${baseCls}__extras`}>
        {isMobile ? (
          <PriceInfoMobile data={priceInfoWithUpgradedServices} />
        ) : (
          <PriceInfo data={priceInfoWithUpgradedServices} />
        )}
      </div>
    </div>
  );
};

SidebarSummary.defaultProps = {
  isRegularFlight: null,
  fullPrice: null,
};

SidebarSummary.propTypes = {
  priceInfo: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape({})),
    PropTypes.array,
  ]).isRequired,
  fullPrice: PropTypes.number,
  showPriceChanged: PropTypes.bool.isRequired,
  isRegularFlight: PropTypes.bool,
  priceChangeDirectionType: PriceChangeDirectionPropTypes.isRequired,
  hotelLink: PropTypes.string.isRequired,
  instantConfirm: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  const hasWorseExtras = getIsFeatureHasAnOption('ab_worse_extras', 'on');
  return {
    fullPrice: getRemainingPaymentAmount(state),
    priceInfo: getPriceInfo(state),
    upgradedServicesInfo: !hasWorseExtras
      ? upgradedServicesSelector(state)
      : [],
    showPriceChanged: getShowPriceChanged(state),
    isRegularFlight: getIsRegularFlight(state),
    priceChangeDirectionType: getPriceChangeDirection(state),
    hotelLink: getHotelLinkWithRequestId(state),
    instantConfirm: getInstantConfirm(state),
    isFetching: getIsOrderPrebuildFetching(state),
    isMobile: getIsMobile(state),
  };
};

export default connect(mapStateToProps)(SidebarSummary);
